import {getElement} from "./utils/getElement";
import Flickity from "flickity";
import "flickity-hash"

const initAddon = () => {
    if (!getElement('.js-screenshots-main') || !getElement('.js-screenshots-nav')) {
        return;
    }

    const navElement = getElement('.js-screenshots-nav');

    const flktyMain = new Flickity('.js-screenshots-main', {
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        wrapAround: true,
        prevNextButtons: false,
        hash: true
    });

    flktyMain.on('select', () => {
        const selectedIndex = flktyMain.selectedIndex;

        // Remove 'is-selected' class from all nav items
        const navItems = navElement.querySelectorAll('a');
        navItems.forEach((item) => {
            item.classList.remove('is-selected');
        });

        // Add 'is-selected' class to the currently selected nav item
        if (navItems[selectedIndex]) {
            navItems[selectedIndex].classList.add('is-selected');
        }
    });
}

export {initAddon}
